const yellow = "/media/diamondcolor/yellow.jpg";
const blue = "/media/diamondcolor/blue.jpg";
const pink = "/media/diamondcolor/pink.jpg";
const green = "/media/diamondcolor/green.jpg";
const orange = "/media/diamondcolor/orange.jpg";
const red = "/media/diamondcolor/red.jpg";

import React from "react";
import RGIcon from "Component/MenuIcons/RGIcon";
import WGIcon from "Component/MenuIcons/WGIcon";
import YGIcon from "Component/MenuIcons/YGIcon";
import RYWGIcon from "Component/MenuIcons/RYWGIcon";
import YWGIcon from "Component/MenuIcons/YWGIcon";
import Titanium from "Component/MenuIcons/Titanium";
import Tungstan from "Component/MenuIcons/Tungstan";
import Solitaire from "Component/MenuIcons/Solitaire";
import Halo from "Component/MenuIcons/Halo";
import Sidestone from "Component/MenuIcons/Sidestone";
import Threestone from "Component/MenuIcons/Threestone";
import Hiddenhalo from "Component/MenuIcons/Hiddenhalo";
import Designerclassic from "Component/MenuIcons/Designerclassic";
import Diamondclassic from "Component/MenuIcons/Diamondclassic";
import Classic from "Component/MenuIcons/Classic";
import Setting from "Component/MenuIcons/Setting";
import NDiamond from "Component/MenuIcons/NDiamond";
import LDiamond from "Component/MenuIcons/LDiamond";
import Diamond from "Component/MenuIcons/Diamond";
import Tahitian from "Component/MenuIcons/Tahitian";
import Golden from "Component/MenuIcons/Golden";
import South from "Component/MenuIcons/South";
import Fresh from "Component/MenuIcons/Fresh";

const MenuLinksData = [
    {
        "label": "Flash Deals",
        "link": "/flash-deals"
    },
    {
        "label": "Engagement Rings",
        "link": "/engagement-ring",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_19.png",
        "categories": [
            {
                "title": "Create Engagement Ring",
                "subcategories": [
                    {
                        "item": "Start with a Setting",
                        "icon": <Setting />,
                        "link": "/customize/ring-settings.html"
                    },
                    {
                        "item": "Start with a Natural Diamond",
                        "icon": <NDiamond />,
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11"
                    },
                    {
                        "item": "Start with a Lab Diamond",
                        "icon": <LDiamond />,
                        "link": "/customize/ring-diamond/lab-grown-diamond.html?diamond_created_from=12"
                    },
                    {
                        "item": "Start with a Natural Colored Diamond",
                        "icon": <Diamond />,
                        "link": "/coloreddiamond?diamond_created_from=11"
                    },
                    {
                        "item": "Start with a Lab Colored Diamond",
                        "icon": <Diamond />,
                        "link": "/coloreddiamond?diamond_created_from=12"
                    }
                ],
                "isIcon": true
            },
            {
                "title": "Shop By Diamond Shapes",
                "subcategories": [
                    {
                        "item": "Round",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Round.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:44"
                    },
                    {
                        "item": "Oval",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Oval.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:45"
                    },
                    {
                        "item": "Pear",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Pear.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:47"
                    },
                    {
                        "item": "Heart",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Heart.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:50"
                    },
                    {
                        "item": "Princess",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Princess.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:46"
                    },
                    {
                        "item": "Marquise",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Marquise.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:52"
                    },
                    {
                        "item": "Emerald",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Emerald.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:48"
                    },
                    {
                        "item": "Radiant",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Radiant.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:51"
                    },
                    {
                        "item": "Cushion",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Cushion.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:49"
                    },
                    {
                        "item": "Asscher",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Asscher.png",
                        "link": "/customize/ring-settings.html?customFilters=shape:53"
                    }
                ],
                "isShape": true
            },
            {
                "title": "Shop by Metal",
                "subcategories": [
                    {
                        "item": "Rose Gold",
                        "icon": <RGIcon />,
                        "link": "/customize/ring-settings.html?customFilters=metal_type:30"
                    },
                    {
                        "item": "Yellow Gold",
                        "icon": <YGIcon />,
                        "link": "/customize/ring-settings.html?customFilters=metal_type:31"
                    },
                    {
                        "item": "White Gold",
                        "icon": <WGIcon />,
                        "link": "/customize/ring-settings.html?customFilters=metal_type:29"
                    },
                    {
                        "item": "Platinum",
                        "icon": <WGIcon />,
                        "link": "/customize/ring-settings.html?customFilters=metal_type:188"
                    }
                ],
                "isIcon": true
            },
            {
                "title": "Shop by Style",
                "subcategories": [
                    {
                        "item": "Halo",
                        "icon": <Halo />,
                        "link": "/customize/ring-settings.html?customFilters=style:73"
                    },
                    {
                        "item": "solitaire",
                        "icon": <Solitaire />,
                        "link": "/customize/ring-settings.html?customFilters=style:74"
                    },
                    {
                        "item": "three stone",
                        "icon": <Threestone />,
                        "link": "/customize/ring-settings.html?customFilters=style:75"
                    },
                    {
                        "item": "side stone",
                        "icon": <Sidestone />,
                        "link": "/customize/ring-settings.html?customFilters=style:77"
                    },
                    {
                        "item": "hidden halo",
                        "icon": <Hiddenhalo />,
                        "link": "/customize/ring-settings.html?customFilters=style:93"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "Shop Pre-Designed Rings",
                "subcategories": [
                    {
                        "item": "All Pre-Designed Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_63.png",
                        "link": "/lab-grown-engagement-rings.html"
                    },
                    {
                        "item": "solitaire engagement rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_64.png",
                        "link": "/lab-grown-engagement-rings/solitaire.html"
                    },
                    {
                        "item": "luxury engagement rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_65.png",
                        "link": "/luxury-engagement-rings.html"
                    },
                    {
                        "item": "gemstone engagement rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_66.png",
                        "link": "/lab-grown-gemstone-rings.html"
                    }
                ],
                "isShown": true
            }
        ]
    },
    {
        "label": "Wedding Rings",
        "link": "/wedding-ring",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_24_2.png",
        "categories": [
            {
                "title": "Shop by Metal",
                "subcategories": [
                    {
                        "item": "Rose Gold",
                        "icon": <RGIcon />,
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=metal_type:30"
                    },
                    {
                        "item": "Yellow Gold",
                        "icon": <YGIcon />,
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=metal_type:31"
                    },
                    {
                        "item": "White Gold",
                        "icon": <WGIcon />,
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=metal_type:29"
                    },
                    {
                        "item": "Platinum",
                        "icon": <WGIcon />,
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=metal_type:188"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "Shop for Her",
                "subcategories": [
                    {
                        "item": "Diamond Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_59.png",
                        "link": "/wedding-rings/women-s-wedding-rings.html"
                    },
                    {
                        "item": "Curved Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_56.png",
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=style:82"
                    },
                    {
                        "item": "Anniversary Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_57.png",
                        "link": "/wedding-rings/women-s-wedding-rings.html"
                    },
                    {
                        "item": "Eternity Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_58.png",
                        "link": "/wedding-rings/women-s-wedding-rings.html?customFilters=style:99"
                    }
                ],
                "isShown": true
            },
            {
                "title": "Shop for Him",
                "subcategories": [
                    {
                        "item": "Diamond",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_60.png",
                        "link": "/men-s-jewelry/men-s-diamond-rings.html"
                    },
                    {
                        "item": "Polish",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_61.png",
                        "link": "/men-s-wedding-rings.html?customFilters=style:739"
                    },
                    {
                        "item": "Solitaire",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_62.png",
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=style:74"
                    }
                ],
                "isShown": true
            }
        ]
    },
    {
        "label": "Fine Jewelry",
        "link": "/fine-jewelry",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_30.png",
        "categories": [
            {
                "title": "Shop by Metal",
                "subcategories": [
                    {
                        "item": "Rose Gold",
                        "icon": <RGIcon />,
                        "link": "/special-jewelry.html?customFilters=metal_type:30"
                    },
                    {
                        "item": "Yellow Gold",
                        "icon": <YGIcon />,
                        "link": "/special-jewelry.html?customFilters=metal_type:31"
                    },
                    {
                        "item": "White Gold",
                        "icon": <WGIcon />,
                        "link": "/special-jewelry.html?customFilters=metal_type:185"
                    },
                    {
                        "item": "Platinum",
                        "icon": <WGIcon />,
                        "link": "/special-jewelry.html?customFilters=metal_type:188"
                    }
                ],
                "isIcon": true
            },
            {
                "title": "Shop by Pearls",
                "subcategories": [
                    {
                        "item": "Tahitian Pearl",
                        "icon": <Tahitian />,
                        "link": "/rings/tahitian-pearl-rings.html"
                    },
                    {
                        "item": "Golden South Sea Pearl",
                        "icon": <Golden />,
                        "link": "/rings/golden-south-see-pearl-rings.html"
                    },
                    {
                        "item": "South Sea Pearl",
                        "icon": <South />,
                        "link": "/rings/south-see-pearl-rings.html"
                    },
                    {
                        "item": "Fresh Water Pearl",
                        "icon": <Fresh />,
                        "link": "/rings/fresh-water-pearl-rings.html"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "All Fine Jewelry",
                "subcategories": [
                    {
                        "item": "All Fine Jewelry",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image40.png",
                        "link": "/special-jewelry.html"
                    },
                    {
                        "item": "Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image35.png",
                        "link": "/lab-grown-engagement-rings.html"
                    },
                    {
                        "item": "Earrings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image36.png",
                        "link": "/earrings/diamond-earrings.html"
                    },
                    {
                        "item": "Bracelets",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image37.png",
                        "link": "/bracelets/diamond-bracelets.html"
                    },
                    {
                        "item": "Pendants",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image38.png",
                        "link": "/pendants/diamond-pendants.html"
                    },
                    {
                        "item": "Lab Grown Jewelry",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image39.png",
                        "link": "/special-jewelry.html"
                    }
                ],
                "isShown": false
            },
            {
                "title": "Shop Pearl Jewelry",
                "subcategories": [
                    {
                        "item": "All Pearl Jewelry",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image41.png",
                        "link": "/rings/tahitian-pearl-rings.html"
                    },
                    {
                        "item": "Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image42.png",
                        "link": "/rings/tahitian-pearl-rings.html"
                    },
                    {
                        "item": "Earrings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image43.png",
                        "link": "/earrings/tahitian-pearl-earrings.html"
                    },
                    {
                        "item": "Pendants",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image44.png",
                        "link": "/pendants/tahitian-pearl-pendants.html"
                    }
                ],
                "isShown": true
            }
        ]
    },
    {
        "label": "Men’s Jewelry",
        "link": "/men-s-jewelry",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_32.png",
        "categories": [
            {
                "title": "Shop by Metal",
                "subcategories": [
                    {
                        "item": "Rose Gold",
                        "icon": <RGIcon />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=metal_type:30"
                    },
                    {
                        "item": "Yellow Gold",
                        "icon": <YGIcon />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=metal_type:31"
                    },
                    {
                        "item": "White Gold",
                        "icon": <WGIcon />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=metal_type:29"
                    },
                    {
                        "item": "Platinum",
                        "icon": <WGIcon />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=metal_type:188"
                    },
                    {
                        "item": "Yellow/White Gold",
                        "icon": <YWGIcon />,
                        "link": "/men-s-jewelry.html?customFilters=metal_type:26"
                    },
                    {
                        "item": "Rose/Yellow/White Gold",
                        "icon": <RYWGIcon />,
                        "link": "/gold-jewelry/gold-chain.html?customFilters=metal_type:184"
                    },
                    {
                        "item": "Tungsten",
                        "icon": <Tungstan />,
                        "link": "/men-s-jewelry/tungsten-rings.html"
                    },
                    {
                        "item": "Titanium",
                        "icon": <Titanium />,
                        "link": "/men-s-jewelry/titanium-rings.html"
                    }
                ],
                "isIcon": true
            },
            {
                "title": "Wedding Collection",
                "subcategories": [
                    {
                        "item": "Diamond Wedding Rings",
                        "icon": <Diamondclassic />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html"
                    },
                    {
                        "item": "Classic Wedding Rings",
                        "icon": <Classic />,
                        "link": "/men-s-wedding-rings.html?customFilters=style:739"
                    },
                    {
                        "item": "Designer Wedding Rings",
                        "icon": <Designerclassic />,
                        "link": "/men-s-jewelry/men-s-diamond-rings.html?customFilters=style:74"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "All Men’s Jewelry",
                "subcategories": [
                    {
                        "item": "All Men’s Jewelry",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_35_.png",
                        "link": "/men-s-jewelry/tungsten-rings.html"
                    },
                    {
                        "item": "Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_36_.png",
                        "link": "/men-s-jewelry/men-s-diamond-rings.html"
                    },
                    {
                        "item": "Earrings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_37_.png",
                        "link": "/men-s-jewelry/men-s-diamond-earrings.html"
                    },
                    {
                        "item": "Bracelets",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_38_.png",
                        "link": "/men-s-jewelry/men-s-diamond-bracelets.html"
                    },
                    {
                        "item": "Pendants",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_40_.png",
                        "link": "/men-s-jewelry/men-s-diamond-pendants.html"
                    },
                    {
                        "item": "Chains",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_39_.png",
                        "link": "/gold-jewelry/gold-chains.html"
                    }
                ],
                "isShown": false
            }
        ]
    },
    {
        "label": "Gold Jewelry",
        "link": "/men-s-jewelry",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_32.png",
        "categories": [
            {
                "title": "Shop by Metal",
                "subcategories": [
                    {
                        "item": "Rose Gold",
                        "icon": <RGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:30"
                    },
                    {
                        "item": "Yellow Gold",
                        "icon": <YGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:31"
                    },
                    {
                        "item": "White Gold",
                        "icon": <WGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:29"
                    },
                    {
                        "item": "Platinum",
                        "icon": <WGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:188"
                    },
                    {
                        "item": "Yellow/White Gold",
                        "icon": <YWGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:26"
                    },
                    {
                        "item": "Rose/Yellow/White Gold",
                        "icon": <RYWGIcon />,
                        "link": "/gold-jewelry.html?customFilters=metal_type:184"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "All Gold Jewelry",
                "subcategories": [
                    {
                        "item": "All Gold Jewelry",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_41_.png",
                        "link": "/gold-jewelry.html"
                    },
                    {
                        "item": "Bracelets",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_42_.png",
                        "link": "/gold-jewelry/gold-bracelets.html"
                    },
                    {
                        "item": "Chains",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_43_.png",
                        "link": "/gold-jewelry/gold-chains.html"
                    }
                ],
                "isShown": false
            },
            {
                "title": "Shop Chains by Style",
                "subcategories": [
                    {
                        "item": "Gold",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_44_.png",
                        "link": "/gold-jewelry/gold-chains.html"
                    },
                    {
                        "item": "Cuban",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_45_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:103"
                    },
                    {
                        "item": "Figaro",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_46_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:105"
                    },
                    {
                        "item": "Franco",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_47_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:107"
                    },
                    {
                        "item": "Miami Cuban",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_48_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:110"
                    },
                    {
                        "item": "Mariner",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_49_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:109"
                    },
                    {
                        "item": "Rope",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_50_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:111"
                    },
                    {
                        "item": "Wheat",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_51_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:114"
                    },
                    {
                        "item": "Curb",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_52_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:135"
                    },
                    {
                        "item": "Valentino",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_53_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:113"
                    },
                    {
                        "item": "Asssorted",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_54_.png",
                        "link": "/gold-jewelry/gold-chains.html?customFilters=style:102"
                    }
                ],
                "isShown": true
            }
        ]
    },
    {
        "label": "Diamonds",
        "link": "/diamonde",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_35_1.png",
        "categories": [
            {
                "title": "Shop By Diamond Shapes",
                "subcategories": [
                    {
                        "item": "Round",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Round.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=44"
                    },
                    {
                        "item": "Oval",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Oval.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=45"
                    },
                    {
                        "item": "Pear",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Pear.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=47"
                    },
                    {
                        "item": "Heart",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Heart.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=50"
                    },
                    {
                        "item": "Princess",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Princess.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=46"
                    },
                    {
                        "item": "Marquise",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Marquise.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=52"
                    },
                    {
                        "item": "Emerald",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Emerald.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=48"
                    },
                    {
                        "item": "Radiant",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Radiant.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=51"
                    },
                    {
                        "item": "Cushion",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Cushion.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=49"
                    },
                    {
                        "item": "Asscher",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Asscher.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11&shape=53"
                    }
                ],
                "isShape": true
            },
            {
                "title": "Shop Diamond by Color",
                "subcategories": [
                    {
                        "item": "Yellow",
                        "image": yellow,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=yellow"
                    },
                    {
                        "item": "Blue",
                        "image": blue,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=blue"
                    },
                    {
                        "item": "Pink",
                        "image": pink,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=pink"
                    },
                    {
                        "item": "Green",
                        "image": green,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=green"
                    },
                    {
                        "item": "Orange",
                        "image": orange,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=orange"
                    },
                    {
                        "item": "Red",
                        "image": red,
                        "link": "/coloreddiamond?diamond_created_from=12&fancy_color_dominant_color=red"
                    }
                ],
                "isIcon": true
            }
        ],
        "categories2": [
            {
                "title": "Design your Own Jewelry",
                "subcategories": [
                    {
                        "item": "Design your Own Diamond Ring",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image__1_35_.png",
                        "link": "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11"
                    },
                    {
                        "item": "Design your Own Colored Diamond Ring",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_24__2.jpg",
                        "link": "/coloreddiamond?diamond_created_from=11"
                    },
                    {
                        "item": "Design your Own Diamond Pendants",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image__1_36_.png",
                        "link": "/customize/pendent-settings.html"
                    }
                ],
                "mergeColumn": true,
                "isShown": false
            }
        ]
    },
    {
        "label": "Gemstones",
        "link": "/gemstones",
        "promotion_banner": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/categorylanding/image_38.png",
        "categories": [
            {
                "title": "Shop by Gemstone",
                "subcategories": [
                    {
                        "item": "sapphire",
                        "image": blue,
                        "link": "/lab-grown-gemstone-rings/blue-sapphire-rings.html"
                    },
                    {
                        "item": "pink",
                        "image": pink,
                        "link": "/lab-grown-gemstone-rings/pink-sapphire-rings.html"
                    },
                    {
                        "item": "yellow",
                        "image": yellow,
                        "link": "/lab-grown-gemstone-rings/pink-sapphire-rings.html"
                    },
                    {
                        "item": "emerald",
                        "image": green,
                        "link": "/lab-grown-gemstone-rings/emerald-rings.html"
                    },
                    {
                        "item": "ruby",
                        "image": red,
                        "link": "/lab-grown-gemstone-rings/ruby-rings.html"
                    }
                ],
                "isShape": true
            },
            {
                "title": "Shop by Color",
                "subcategories": [
                    {
                        "item": "Yellow",
                        "image": yellow,
                        "link": "/lab-grown-gemstone-rings.html?customFilters=gemstonetype:887"
                    },
                    {
                        "item": "Blue",
                        "image": blue,
                        "link": "/lab-grown-gemstone-rings.html?customFilters=gemstonetype:885"
                    },
                    {
                        "item": "Pink",
                        "image": pink,
                        "link": "/lab-grown-gemstone-rings.html?customFilters=gemstonetype:886"
                    },
                    {
                        "item": "Green",
                        "image": green,
                        "link": "/lab-grown-gemstone-rings.html?customFilters=gemstonetype:888"
                    },
                    {
                        "item": "Red",
                        "image": red,
                        "link": "/lab-grown-gemstone-rings.html?customFilters=gemstonetype:884"
                    }
                ],
                "isIcon": true
            },
            {
                "title": "Shop By Shapes",
                "subcategories": [
                    {
                        "item": "Round",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Round.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:44"
                    },
                    {
                        "item": "Oval",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Oval.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:45"
                    },
                    {
                        "item": "Pear",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Pear.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:47"
                    },
                    {
                        "item": "Heart",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Heart.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:50"
                    },
                    {
                        "item": "Princess",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Princess.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:46"
                    },
                    {
                        "item": "Marquise",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Marquise.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:52"
                    },
                    {
                        "item": "Emerald",
                        "image": "https://ik.imagekit.io/solc130re/media/.thumbswysiwyg/sparklehomepage/Emerald.png",
                        "link": "/lab-grown-gemstone-rings.html?customFilters=shape:48"
                    },
                ],
                "isShape": true
            }
        ],
        "categories2": [
            {
                "title": "Pre Designed Gemstone Rings",
                "subcategories": [
                    {
                        "item": "Pre Designed Gemstone Rings",
                        "image": "https://ik.imagekit.io/solc130re/media/.renditions/wysiwyg/navigation/image_55.png",
                        "link": "/lab-grown-gemstone-rings.html"
                    }
                ],
                "mergeColumn": true,
                "isShown": false
            }
        ]
    },
    // {
    //     "label": "Pearl Jewelry",
    //     "categories": [
    //         {
    //             "title": "Rings",
    //             "subcategories": [
    //                 {
    //                     "item": "Tahitian Pearl",
    //                     "link": "/rings/tahitian-pearl-rings.html"
    //                 },
    //                 {
    //                     "item": "Golden South Sea Pearl",
    //                     "link": "/rings/golden-south-see-pearl-rings.html"
    //                 },
    //                 {
    //                     "item": "South Sea Pearl",
    //                     "link": "/rings/south-see-pearl-rings.html"
    //                 },
    //                 {
    //                     "item": "Fresh Water Pearl",
    //                     "link": "/rings/fresh-water-pearl-rings.html"
    //                 }
    //             ]
    //         },
    //         {
    //             "title": "Earrings",
    //             "subcategories": [
    //                 {
    //                     "item": "Tahitian Pearl",
    //                     "link": "/earrings/tahitian-pearl-earrings.html"
    //                 },
    //                 {
    //                     "item": "Golden South Sea Pearl",
    //                     "link": "/earrings/golden-south-see-pearl-earrings.html"
    //                 },
    //                 {
    //                     "item": "South Sea Pearl",
    //                     "link": "/earrings/south-see-pearl-earrings.html"
    //                 },
    //                 {
    //                     "item": "Fresh Water Pearl",
    //                     "link": "/earrings/fresh-water-pearl-earrings.html"
    //                 }
    //             ]
    //         },
    //         {
    //             "title": "Pendants",
    //             "subcategories": [
    //                 {
    //                     "item": "Tahitian Pearl",
    //                     "link": "/pendants/tahitian-pearl-pendants.html"
    //                 },
    //                 {
    //                     "item": "Golden South Sea Pearl",
    //                     "link": "/pendants/golden-south-sea-pearl-pendants.html"
    //                 },
    //                 {
    //                     "item": "South Sea Pearl",
    //                     "link": "/pendants/south-sea-pearl-pendants.html"
    //                 },
    //                 {
    //                     "item": "Fresh Water Pearl",
    //                     "link": "/pendants/fresh-water-pearl-pendants.html"
    //                 }
    //             ]
    //         }
    //     ]
    // },
    {
        "label": "About BLUEHIRA",
        "link": "/about"
    }
];

export default MenuLinksData;